import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import {initialize as initializeForm, reset} from "redux-form";
import {NotificationManager} from "react-notifications";
import {push} from "react-router-redux";
import moment from 'moment';
import _ from "lodash";

const LOADER = 'LOADER_NOTIFICACIONES';
const DATA = 'DATA_NOTIFICACIONES';
const PAGE = 'PAGE_NOTIFICACIONES';
const ORDERING = 'ORDERING_NOTIFICACIONES';
const SEARCH = 'SEARCH_NOTIFICACIONES';
const FECHA = 'FECHA_NOTIFICACIONES';


// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setData = (type, data) => ({
    type,
    data,
});

const setPage = page => ({
    type: PAGE,
    page,
});

const setOrdering = ordering => ({
    type: ORDERING,
    ordering,
});

const setSearch = search => ({
    type: SEARCH,
    search,
});

// ------------------------------------
// Actions
// ------------------------------------

const listar = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().notificaciones;
    const params = { page };
    params.ordering = resource.ordering;
    params.search = resource.search;
    if (resource.fecha)
        params.fecha = moment(resource.fecha).hour(0).minute(0).seconds(0).format()
    dispatch(setLoader(true));
    api.get('notificaciones', params).then((response) => {
        dispatch(setData(DATA, response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const ver = path => (dispatch) => {
    dispatch(push(path));
}

const searchChange = search => (dispatch) => {
    dispatch(setSearch(search));
    dispatch(listar());
};

const onSortChange = ordering => (dispatch, getStore) => {
    const sort = getStore().administradores.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listar());
};

const changeFecha = value => (dispatch) => {
    dispatch(setData(FECHA, value));
    dispatch(listar());
}

export const actions = {
    listar,
    ver,
    searchChange,
    onSortChange,
    changeFecha,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [FECHA]: (state, { data }) => {
        return {
            ...state,
            fecha: data,
        };
    },
};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    page: 1,
    ordering: '',
    search: '',
    fecha: null,
};

export default handleActions(reducers, initialState);
